import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import whiteLogo from '../assets/whitelogo.png';
import './Welcome.css';

const Welcome = () => {
  const [greeting, setGreeting] = useState('');
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    // Redirect if already authenticated
    if (isAuthenticated) {
      navigate('/dashboard');
      return;
    }

    const updateGreeting = () => {
      const hour = new Date().getHours();
      if (hour < 12) {
        setGreeting('Good Morning');
      } else if (hour < 18) {
        setGreeting('Good Afternoon');
      } else {
        setGreeting('Good Evening');
      }
    };

    updateGreeting();
    // Update greeting every minute to handle day transitions
    const interval = setInterval(updateGreeting, 60000);

    return () => clearInterval(interval);
  }, [isAuthenticated, navigate]);

  const handleContinue = () => {
    navigate('/login');
  };

  return (
    <div className="welcome-container">
      <div className="welcome-content">
        <div className="welcome-animation">
          <img src={whiteLogo} alt="VisionExploit" className="welcome-logo" />
        </div>
        <h1 className="welcome-greeting">{greeting}!</h1>
        <p className="welcome-message">Welcome to VEC Management System</p>
        <p className="welcome-subtitle">
          Your comprehensive platform for managing students, agents, and interactions
        </p>
        <button className="welcome-button" onClick={handleContinue}>
          Continue to Login
        </button>
      </div>
      <div className="welcome-footer">
        <p>© {new Date().getFullYear()} VisionExploit. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Welcome;

